import * as tslib_1 from "tslib";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { isFunction, dynamicScriptLoad } from "../../helpers";
import { BaseBlock } from "../BaseBlock";
var AsyncBlockDownloadStatuses;
(function (AsyncBlockDownloadStatuses) {
    AsyncBlockDownloadStatuses["success"] = "0";
    AsyncBlockDownloadStatuses["fail"] = "1";
    AsyncBlockDownloadStatuses["pending"] = "2";
})(AsyncBlockDownloadStatuses || (AsyncBlockDownloadStatuses = {}));
/**
 * AsyncBlockInit provides dummy block instance that can handle asyncronous loading of
 * JavaScript artifacts and init any Responsive or React block before its source was
 * downloaded on the page.
 */
var AsyncBlockInit = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncBlockInit, _super);
    /**
     * Constructor
     * @param {SBMsgBus} bus used for messages exchange
     * @param {String} blockClassName Unique name of the block constructor function or class
     * @param {String} domId unique ID used for identifying correct DOM element and message bus topic for the instance
     * @param {AsyncBlockOptions} config Extended config
     * @param {Any} rest Any other parametters passed to the constructor are stored and passed on during init
     */
    function AsyncBlockInit(bus, blockClassName, domId, config) {
        var rest = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            rest[_i - 4] = arguments[_i];
        }
        var _this = _super.call(this, domId, config) || this;
        _this.block;
        _this.bus = bus;
        _this.rest = rest;
        _this.panelId = "";
        _this.domId = domId;
        _this.config = config;
        _this.isLoaded = false;
        _this.class = blockClassName;
        _this.paramsToSet = undefined;
        _this.uniqueTopic = "" + _this.bus.sbPrefix + domId;
        _this.classTopic = "" + _this.bus.sbPrefix + blockClassName + "_loaded";
        _this.instanceTopic = _this.uniqueTopic + "_loaded";
        _this.loaded = _this.loaded.bind(_this);
        _this.busMsgRouter = _this.busMsgRouter.bind(_this);
        _this.isCodeLoaded = Array.isArray(config.requires) === true ?
            AsyncBlockDownloadStatuses.pending :
            AsyncBlockDownloadStatuses.success; // no files - trigger the success flow
        _this.bus.subscribe("" + _this.classTopic, _this.loaded);
        return _this;
    }
    /**
     * membersRemap, execute once method that links between members of the real block and dummy block
     */
    AsyncBlockInit.prototype.membersRemap = function () {
        var _this = this;
        // defensive coding for smartasses
        if (this.isLoaded) {
            // compatibility with mobile app
            var legacyCompatibalityProps_1 = { PanelID: "panelId", parentBlock: "ParentBlock" };
            Object.keys(legacyCompatibalityProps_1).forEach(function (x) { return Object.defineProperty(_this.block, x, {
                get: function () { return _this[legacyCompatibalityProps_1[x]]; },
                set: function (y) { return _this[legacyCompatibalityProps_1[x]] = y; }
            }); });
            var _loop_1 = function (m) {
                if (m !== "activate" &&
                    m !== "setParams" &&
                    m !== "destroy") {
                    if (typeof this_1.block[m] === "function") {
                        this_1[m] = this_1.block[m];
                    }
                    else {
                        Object.defineProperty(this_1, m, {
                            get: function () {
                                return _this.block[m];
                            },
                            set: function (x) { return _this.block[m] = x; }
                        });
                    }
                }
            };
            var this_1 = this;
            for (var m in this.block) {
                _loop_1(m);
            }
            // You better lose yourself in the music, the moment
            // You own it, you better never let it go
            // You only get one shot, do not miss your chance to blow
            // This opportunity comes once in a lifetime
            this.membersRemap = function () { return undefined; };
        }
        return undefined;
    };
    /**
     * loaded, execute once method that creates instance of the real block after its code was downloaded on the page
     * @param {Boolean} x received as message from the block that loaded
     */
    AsyncBlockInit.prototype.loaded = function (x) {
        var _this = this;
        var _a, _b;
        if (x === true && typeof window[this.class] === "function") {
            this.isLoaded = x;
            try {
                this.block = new ((_a = window[this.class]).bind.apply(_a, tslib_1.__spread([void 0, this.domId, this.config], this.rest)))();
            }
            catch (up) {
                throw up;
            }
            this.membersRemap();
            this.bus.unsubscribe("" + this.classTopic, this.loaded);
            this.bus.subscribe("" + this.uniqueTopic, this.busMsgRouter);
            this.bus.post((_b = {}, _b["" + this.instanceTopic] = true, _b));
            this.loaded = function () { return _this; };
        }
        return this;
    };
    /**
     * busMsgRouter, routes any async messages sent to the block togher with any data sent
     * @param {AsyncBlockTopic} x parametters for the method called via sbMsgBus.post(...)
     */
    AsyncBlockInit.prototype.busMsgRouter = function (x) {
        var _this = this;
        x && Object.keys(x).forEach(function (y) {
            if (_this.isLoaded && isFunction(_this.block[y])) {
                try {
                    _this[y](x[y]);
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    };
    /**
     * destroy, calls super.destroy(), then unsubscribes from the bus leaving the block dead
     */
    AsyncBlockInit.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.bus.unsubscribe("" + this.uniqueTopic, this.busMsgRouter);
        return this;
    };
    /**
     * setParams, proxy of block.setParams, that works in async way. Stores params in order to pass them
     * to the block once it is downloaded and its instance is created
     * @param {Any} x params to proxy
     */
    AsyncBlockInit.prototype.setParams = function () {
        var _a;
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
        }
        if (this.isLoaded) {
            return (_a = this.block).setParams.apply(_a, tslib_1.__spread(x));
        }
        else {
            this.paramsToSet = x;
        }
        return this;
    };
    /**
     * activate, async version of the activate method available to the application before the
     * real block is downloaded and init. If called directly it is going to post message to
     * to its own topic.
     * @param {Array<any>} x params to proxy
     */
    AsyncBlockInit.prototype.activate = function () {
        var _this = this;
        var _a, _b, _c;
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
        }
        if (this.isCodeLoaded === AsyncBlockDownloadStatuses.pending) {
            dynamicScriptLoad(this.config.requires || [], function () { return _this.isCodeLoaded = AsyncBlockDownloadStatuses.success; }, function (e) {
                _this.isCodeLoaded = AsyncBlockDownloadStatuses.fail;
                _this.bus.unsubscribe("" + _this.uniqueTopic, _this.busMsgRouter);
                throw new Error("Block \"" + _this.class + "\" download failed! With error: " + e.toString());
            });
        }
        if (this.isLoaded && this.isCodeLoaded === AsyncBlockDownloadStatuses.success) {
            if (this.paramsToSet) {
                (_a = this.block).setParams.apply(_a, tslib_1.__spread(this.paramsToSet));
                this.paramsToSet = undefined;
            }
            return (_b = this.block).activate.apply(_b, tslib_1.__spread(x));
        }
        else {
            this.bus.post((_c = {}, _c[this.uniqueTopic] = { activate: x }, _c));
            try {
                this.renderLoader();
            }
            catch (up) {
                throw up;
            }
        }
        return this;
    };
    AsyncBlockInit.prototype.renderLoader = function () {
        var domRef = document.getElementById(this.domId);
        if (!domRef) {
            throw new Error("Element with ID " + this.domId + " does not exist.");
        }
        else {
            // TODO: consume the loader in a smarter way
            ReactDOM.render((React.createElement("div", { className: "rj-loader" },
                React.createElement("div", { className: "rj-loader-spinner rj-loader-container" },
                    React.createElement("div", { className: "rj-loader-spinner rj-loader-fill" },
                        React.createElement("div", { className: "rj-loader-clipper left" },
                            React.createElement("div", { className: "rj-loader-circle" })),
                        React.createElement("div", { className: "rj-loader-gap-patch" },
                            React.createElement("div", { className: "rj-loader-circle" })),
                        React.createElement("div", { className: "rj-loader-clipper right" },
                            React.createElement("div", { className: "rj-loader-circle" })))))), domRef);
        }
    };
    return AsyncBlockInit;
}(BaseBlock));
export { AsyncBlockInit };
//# sourceMappingURL=AsyncBlockInit.js.map